<template>
    <div class="dotsWrapper" :style="wrapperStyles">
        <div class="spinner" :style="spinnerStyles">
            <div class="bounce1" :style="dotsStyles"></div>
            <div class="bounce2" :style="dotsStyles"></div>
            <div class="bounce3" :style="dotsStyles"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            showBg: {
              type: Boolean,
              default: false
            },
            bgColor: String,
            type: String
        },
        data() {
          return {
            windowWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
          };
        },
        computed: {
          isSidebarShown() {
            return this.windowWidth > 1480;
          },
          wrapperStyles() {
            const botStyles =  {
                color: '#fff',
                backgroundColor: '#fff',
            }
            const userStyles =  {
                color: '#fff',
                backgroundColor: '#0165FF',
            }
            if (this.showBg) {
              styles.background = '#b6bcc278'
            }
            
            if (this.type === 'bot') {
              return botStyles;
            }
            if (this.type === 'user') {
              return userStyles;
            }
          },
          dotsStyles() {
            const style = {
              background: this.type === 'bot' ? '#0165FF' : '#fff',
            }

            if (this.type === 'screen-loader') {
              return {
                ...style,
                width: '15px',
                height: '15px'
              }
            } else {
              return style
            }
          },
          spinnerStyles() {
            if (this.type === 'screen-loader') {
              return {
                position: 'absolute',
                top: '50%',
                left: this.isSidebarShown ? `calc(50% + 140px)` : '50%',
                transform: 'translate(-50%, -50%)'
              }
            }
          }
        },
        mounted() {
          window.addEventListener('resize', this.handleResize);
        },
        beforeDestroy() {
          window.removeEventListener('resize', this.handleResize);
        },
        methods: {
          handleResize() {
            this.windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
          }
        }
      }
</script>

<style scoped lang="scss">
.dotsWrapper {
  padding: 10px;
  display: flex;
  justify-content: flex-start;
}

.spinner {
  display: flex;
  gap: 2px;
}

.spinner > div {
  width: 6px;
  height: 6px;
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1s infinite ease-in-out both;
  animation: sk-bouncedelay 1s infinite ease-in-out both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

.spinner .bounce3 {
  -webkit-animation-delay: 0s;
  animation-delay: 0s;
}

@-webkit-keyframes sk-bouncedelay {
  0%, 100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  40% {
    -webkit-transform: translateY(-4px);
    transform: translateY(-4px);
  }
  80% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}

@keyframes sk-bouncedelay {
  0%, 100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  40% {
    -webkit-transform: translateY(-4px);
    transform: translateY(-4px);
  }
  80% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
</style>